export const SALARY_FULL_INFO_QUERY_KEY = 'salaryFullInfoQueryKey'
export const SALARY_EMPLOYEES_FULL_INFO_QUERY_KEY = 'salaryEmployeesFullInfoQueryKey'
export const SALARY_EMPLOYEES_ITEMS_QUERY_KEY = 'salaryEmployeesItemsQueryKey'
